import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
import { Accordion } from '../ui/Accordion';
import { Button } from '../ui/Button';
const faqs = [{
  question: '¿Necesito experiencia en edición?',
  answer: 'No. El sistema está diseñado para principiantes. Te enseñaremos paso a paso cómo utilizar las herramientas de IA para que hagan el trabajo pesado por ti.'
}, {
  question: '¿Necesito saber de Inteligencia Artificial?',
  answer: "Tampoco. Te daremos los 'prompts' (instrucciones) exactos que debes copiar y pegar para obtener resultados profesionales."
}, {
  question: '¿Cuánto tiempo tarda completar el entrenamiento?',
  answer: 'El curso es directo al grano. En aproximadamente 1 a 2 horas habrás visto todo el material y estarás listo para crear tu primer video.'
}, {
  question: '¿Necesito programas costosos?',
  answer: 'No. Te enseñaremos a utilizar herramientas accesibles y te mostraremos opciones gratuitas para que puedas empezar sin costos adicionales.'
}, {
  question: '¿Recibo acceso inmediato?',
  answer: 'Sí. Al completar tu pago, recibirás un correo electrónico con tus credenciales para acceder a la plataforma y a todo el contenido de forma inmediata.'
}];
export function FooterCTA() {
  return <div className="relative" data-id="element-92">
      {/* Who is it for */}
      <section className="py-[64px] md:py-[96px] bg-bg-secondary" data-id="element-93">
        <div className="container mx-auto px-5 max-w-[1100px]" data-id="element-94">
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          ease: [0.16, 1, 0.3, 1]
        }} className="text-center mb-16" data-id="element-95">
            <h2 className="text-[32px] md:text-[48px] font-[900] text-white uppercase tracking-tight" data-id="element-96">
              ¿ESTO ES PARA TI?
            </h2>
          </motion.div>

          <div className="grid md:grid-cols-2 gap-[24px]" data-id="element-97">
            {/* Left Column */}
            <motion.div initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            ease: [0.16, 1, 0.3, 1]
          }} className="bg-bg-card border border-border-card rounded-[16px] p-[36px] hover:-translate-y-[6px] hover:border-accent-border hover:shadow-[0_12px_40px_rgba(0,180,230,0.1)] transition-all duration-250" data-id="element-98">
              <h3 className="text-danger font-[700] uppercase text-[12px] tracking-widest mb-6" data-id="element-99">
                ✗ PARA QUIÉN NO ES
              </h3>
              <div className="h-px w-full bg-border-subtle mb-6" data-id="element-100" />
              <div className="space-y-4" data-id="element-101">
                {['Personas que no venden propiedades', 'Agentes que no usan redes sociales', 'Quienes buscan resultados sin publicar'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-102">
                    <X className="w-5 h-5 text-danger shrink-0 mt-1" data-id="element-103" />
                    <span className="text-white text-[15px] leading-[2.2]" data-id="element-104">
                      {item}
                    </span>
                  </div>)}
              </div>
            </motion.div>

            {/* Right Column */}
            <motion.div initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.1,
            ease: [0.16, 1, 0.3, 1]
          }} className="bg-bg-card border border-accent-border shadow-[0_0_30px_rgba(0,180,230,0.06)] rounded-[16px] p-[36px] hover:-translate-y-[6px] hover:shadow-[0_12px_40px_rgba(0,180,230,0.15)] transition-all duration-250" data-id="element-105">
              <h3 className="text-accent font-[700] uppercase text-[12px] tracking-widest mb-6" data-id="element-106">
                ✦ PARA QUIÉN SÍ ES
              </h3>
              <div className="h-px w-full bg-border-subtle mb-6" data-id="element-107" />
              <div className="space-y-4" data-id="element-108">
                {['Agentes inmobiliarios independientes', 'Inmobiliarias pequeñas y medianas', 'Desarrolladores con propiedades para vender', 'Agentes que quieren destacar en redes', 'Cualquiera que venda propiedades en LATAM'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-109">
                    <Check className="w-5 h-5 text-success shrink-0 mt-1" data-id="element-110" />
                    <span className="text-white text-[15px] leading-[2.2]" data-id="element-111">
                      {item}
                    </span>
                  </div>)}
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-[64px] md:py-[96px] bg-bg-primary" data-id="element-112">
        <div className="container mx-auto px-5 max-w-[1100px]" data-id="element-113">
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          ease: [0.16, 1, 0.3, 1]
        }} className="text-center mb-16" data-id="element-114">
            <h2 className="text-[32px] md:text-[48px] font-[900] uppercase text-white" data-id="element-115">
              PREGUNTAS FRECUENTES
            </h2>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2,
          ease: [0.16, 1, 0.3, 1]
        }} data-id="element-116">
            <Accordion items={faqs} data-id="element-117" />
          </motion.div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-[64px] md:py-[96px] bg-bg-secondary border-t border-border-subtle relative overflow-hidden" data-id="element-118">
        <div className="container mx-auto px-5 relative z-10" data-id="element-119">
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          ease: [0.16, 1, 0.3, 1]
        }} className="max-w-[520px] mx-auto text-center flex flex-col items-center" data-id="element-120">
            <h2 className="text-[36px] md:text-[56px] font-[900] mb-6 uppercase tracking-tight leading-[1.1] text-white" data-id="element-121">
              EL MOMENTO DE ACTUAR
              <br data-id="element-122" />
              <span className="text-accent" data-id="element-123">ES AHORA.</span>
            </h2>

            <p className="text-[18px] text-text-secondary mb-12 font-[500]" data-id="element-124">
              Cada día sin VideoInmo AI es un día que tu competencia te lleva
              ventaja.
            </p>

            <div className="mb-10" data-id="element-125">
              <div className="text-[48px] font-[900] text-white leading-none" data-id="element-126">
                S/49.90
              </div>
              <p className="text-[14px] text-text-secondary font-medium mt-2" data-id="element-127">
                Pago único, acceso de por vida
              </p>
            </div>

            <Button href="https://etsdvu-71.myshopify.com/cart/43467725832281:1" fullWidth className="mb-6" data-id="element-128">
              OBTENER ACCESO POR S/49.90 →
            </Button>

            <p className="text-[13px] text-text-muted" data-id="element-129">
              Pago único · Acceso inmediato · Garantía 7 días
            </p>
          </motion.div>
        </div>
      </section>
    </div>;
}